import { CircularProgress } from "@mui/material";

export const Loading = () => (
  <div className="mx-auto">
    <CircularProgress />
  </div>
);

export default Loading;
